import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import logo from '../assets/logo.png';

const Hero = () => {
  const WHATSAPP_GROUP_URL = "https://chat.whatsapp.com/KSljOanAu6M8aE2PFyT9nF";

  return (
    <section 
      id="hero" 
      className="bg-glow-container"
      style={{
        minHeight: '92vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: '80px 24px',
        position: 'relative',
        background: 'radial-gradient(circle at 50% -20%, #0c203b 0%, #071328 60%, #050b14 100%)',
      }}
    >
      {/* Decorative Blur Spheres */}
      <div 
        className="bg-glow-sphere" 
        style={{ 
          width: '35vw', 
          height: '35vw', 
          background: 'var(--mga-gold)', 
          top: '-10%', 
          left: '10%' 
        }} 
      />
      <div 
        className="bg-glow-sphere" 
        style={{ 
          width: '40vw', 
          height: '40vw', 
          background: 'var(--mga-navy-light)', 
          bottom: '10%', 
          right: '5%' 
        }} 
      />

      {/* Grid Pattern Overlay */}
      <div style={{
        position: 'absolute',
        inset: 0,
        backgroundImage: 'radial-gradient(rgba(242,184,7,0.06) 1px, transparent 1px)',
        backgroundSize: '32px 32px',
        opacity: 0.8,
        pointerEvents: 'none',
        zIndex: 1
      }} />

      <div style={{ position: 'relative', zIndex: 2, maxWidth: '900px', margin: '0 auto' }}>
        
        {/* Animated Badge */}
        <motion.div
          initial={{ opacity: 0, y: 15 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <span className="badge-gold">
            🛡️ Projet Technologique Citoyen
          </span>
        </motion.div>

        {/* Floating Logo */}
        <motion.div
          initial={{ opacity: 0, scale: 0.85 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, type: 'spring' }}
          className="floating-logo"
          style={{ marginBottom: '30px' }}
        >
          <img
            src={logo}
            alt="Logo MonAlerte"
            style={{ 
              width: 'clamp(120px, 15vw, 160px)', 
              filter: 'drop-shadow(0 15px 35px rgba(242,184,7,0.25))' 
            }}
          />
        </motion.div>

        {/* Heading */}
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.1 }}
          style={{
            fontSize: 'clamp(2.5rem, 6.5vw, 4.6rem)',
            fontWeight: 900,
            lineHeight: 1.1,
            marginBottom: '20px',
            color: 'var(--mga-white)'
          }}
        >
          Le Projet <span style={{ 
            background: 'linear-gradient(135deg, var(--mga-gold) 0%, var(--mga-gold-light) 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent'
          }}>MonAlerte</span>
        </motion.h1>

        {/* Subtitle / Pitch */}
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          style={{
            fontSize: 'clamp(1.1rem, 2.5vw, 1.45rem)',
            color: 'var(--mga-slate-300)',
            marginBottom: '40px',
            lineHeight: '1.6',
            fontWeight: 400,
            maxWidth: '780px',
            margin: '0 auto 40px auto'
          }}
        >
          Mettre la technologie au service de la sécurité de tous.
          <br />
          <span style={{ fontSize: '0.95em', opacity: 0.85 }}>
            Une solution souveraine, collaborative et discrète pour vous et vos proches face aux risques du quotidien.
          </span>
        </motion.p>

        {/* CTA Buttons */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.3 }}
          style={{ 
            display: 'flex', 
            gap: '18px', 
            flexWrap: 'wrap', 
            justifyContent: 'center' 
          }}
        >
          <Link
            to="/rejoindre"
            className="button-primary"
            style={{ minWidth: '240px' }}
          >
            Rejoindre gratuitement
          </Link>
          <a 
            href={WHATSAPP_GROUP_URL} 
            target="_blank" 
            rel="noopener noreferrer" 
            className="button-secondary" 
            style={{ minWidth: '240px' }}
          >
            💬 Groupe WhatsApp Co-création
          </a>
        </motion.div>

      </div>
    </section>
  );
};

export default Hero;
